import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../repositories/common/json_query';

export function trackOfferCardShow({
  position,
  offerId,
  jsonQuery,
  contextToken,
}: {
  position: number;
  offerId: number;
  jsonQuery: IJsonQuery;
  contextToken?: string;
}): void {
  ca('teaser', {
    product: {
      block: 'Listing_snippet',
      extra: {
        offerType: 'offer',
        ...(contextToken ? { context_token: contextToken } : null),
      },
      id: offerId,
      name: 'show_card',
      position,
      screen: 'Listing',
    },
    sc: jsonQuery,
  });
}
